import {parse, stringify} from 'query-string';
import {log} from "util";

type ClientProps = {
	body?: any,
	customConfig?: any,
	// Sent as the x-api-key header (a snippet session key for the v5 snippet APIs).
	apiKey?: string,
	headers?: Record<string, string>,
}

async function client(host: string, endpoint: string, props: ClientProps = {}) {
	if (host === 'login' && endpoint === 'test') {
		if (props.body.UserName === 'bad')
			return Promise.reject('Invalid Credentials')
		
		return Promise.resolve({  session: "Test Key" })
	}

	const body = props.body;
	const customConfig = props.customConfig;
	const headers: any = props.apiKey ? {'content-type': 'application/json', 'x-api-key': props.apiKey} : {'content-type': 'application/json'}
	const config = {
		method: body ? 'POST' : 'GET',
		...customConfig,
		headers: {
			...headers,
			...props.headers,
		},
	}
	if (body) {
		config.body = JSON.stringify(body)
	}
	
	const url = `${host}/${endpoint}`

	return window
		.fetch(url, config)
		.then(async r => {
			// An invalid or expired snippet session key comes from the page, so logging out and reloading would only repeat it.
			// The same goes for snippet access with no key yet (the eGift snippet on a page with no cart).
			if (r.status === 401 && props.apiKey !== undefined)
				return Promise.reject('Your session has expired. Please refresh the page.')

			if (r.status === 401) {
				//Expired Key??
				logout()
				// refresh the page for them
				// @ts-ignore
				window.location.assign(window.location)
				return
			}

			// Determine response type based on Content-Type header
			const contentType = r.headers.get('Content-Type');

			// Parse JSON only if content type is application/json
			let data: any;
			if (contentType && contentType.includes('application/json')) {
				data = await r.json();
			} else {
				// Handle other types (e.g., text/plain, or raw files like .json)
				data = await r.text();
				// If needed, attempt to parse text as JSON
				try {
					data = JSON.parse(data);
					data.status = 'success'
				} catch (e) {
					// Handle non-JSON content (return raw text or throw an error)
					return Promise.reject('Response is not valid JSON');
				}
			}
			if (data.status === 'success') {
				return data
			} else {
				return Promise.reject(data.message)
			}
		})
}

const logout = () => {
	sessionStorage.removeItem('blCustomer')
	sessionStorage.removeItem('blSkippedContact')
	sessionStorage.removeItem('blMembershipTypeSet')
	sessionStorage.removeItem('blCurrentPage')
	sessionStorage.removeItem('blMembershipType')
	sessionStorage.removeItem('blGiftRecipient')
	sessionStorage.removeItem('blGiftRecipientSessionKey')
	sessionStorage.removeItem('bL_sk')
	sessionStorage.removeItem('blSessionKey')
	let params = parse(window.location.search)
	delete params.blSessionKey
	delete params.bL_sk
	delete params.bl_sk
	const props = Object.keys(params);
	window.location.assign(window.location.origin + (props.length > 0 ? '?' + stringify(params) : ''))

}

export { client, logout }
